import { useAppDispatch } from 'common/hooks/redux';
import { WizardStepProps } from '../PowerpointExportWizard';
import { setWizardStep } from 'common/store/slices/export-ppt.slice';
import { FlyoutBase, FlyoutBody } from '../Flyout';
import { Typography } from '@progress/kendo-react-common';
import Option from './Option';
import useFeatureFlags from 'common/hooks/useFeatureFlags';
import { Feature } from 'common/models/page-config.models';
import { FlyoutHeader } from '../components/FlyoutHeader';
import { WizardStep } from '../../../models/pptx.model';

function ChooseType({ onClose }: Readonly<WizardStepProps>) {
  const dispatch = useAppDispatch();
  const { hasFeature } = useFeatureFlags();
  const hasMultiExport = hasFeature(Feature.MultipleQuestionExport);
  const onSummaryPageExport = () => {
    dispatch(setWizardStep(WizardStep.PowerpointExportSummary));
  };

  const onQuestionExport = () => {
    dispatch(setWizardStep(WizardStep.PowerpointExportQuestion));
  };

  return (
    <FlyoutBase rootClassName="flyout-paginated-ppt-export" onOverlayClick={onClose}>
      <FlyoutHeader title={'Configure PowerPoint Export'} onCloseClick={onClose} />
      <FlyoutBody>
        {hasMultiExport && (
          <Typography.p className="heading">What do you want to export?</Typography.p>
        )}
        <div className="card-options-list">
          <Option
            onClick={onSummaryPageExport}
            title={'Page Export'}
            description={
              '<p class="k-paragraph">Export selected tiles from the summary page, with each visual on its own slide.</p>'
            }
            image={'/src/assets/ppt-export/summary-page-export.png'}
          />
          {hasMultiExport && (
            <Option
              onClick={onQuestionExport}
              title={'Multiple Question Export'}
              description={
                '<p class="k-paragraph">Choose multiple questions for export, with <b>each slide providing a specific question’s summary.</b></p>'
              }
              image={'/src/assets/ppt-export/multiple-question-export.png'}
            />
          )}
        </div>
      </FlyoutBody>
    </FlyoutBase>
  );
}

export default ChooseType;
